import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { SP_ICONS, SPIcon } from '../../icons/sp-icons';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  template: `
    <ng-container *ngIf="customIcon; else lucideTemplate">
      <svg
        [attr.viewBox]="customIcon.viewBox"
        [attr.width]="size"
        [attr.height]="size"
        [attr.stroke-width]="strokeWidth"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="custom-icon"
      >
        <path
          *ngFor="let p of customIcon.paths"
          [attr.d]="getPathData(p)"
          [attr.fill]="getPathColor(p) || color"
        ></path>
      </svg>
    </ng-container>
    <ng-template #lucideTemplate>
      <lucide-icon
        [name]="name"
        [size]="size"
        [color]="color"
        [strokeWidth]="strokeWidth"
      ></lucide-icon>
    </ng-template>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .custom-icon {
      display: block;
    }
  `]
})
export class AppIconComponent {
  @Input() name: string = '';
  @Input() size: number | string = 24;
  @Input() color: string = 'currentColor';
  @Input() strokeWidth: number | string = 2;

  get customIcon(): SPIcon | null {
    return SP_ICONS[this.name] || null;
  }

  getPathData(p: string | any): string {
    return typeof p === 'string' ? p : p.d;
  }

  getPathColor(p: string | any): string | undefined {
    return typeof p === 'string' ? undefined : p.color;
  }
}
